import React from "react";
import "./Footer.css";
import Wave from "../../img/wave.png";
import Insta from "@iconscout/react-unicons/icons/uil-instagram";
import Facebook from "@iconscout/react-unicons/icons/uil-facebook";
import Gitub from "@iconscout/react-unicons/icons/uil-github";
import Linkedin from "@iconscout/react-unicons/icons/uil-linkedin";


const Footer = () => {
  return (
    <div className="footer">
      <img src={Wave} alt="" style={{ width: "100%" }} />
      <div className="f-content">
         <br></br>
        <span>milurenus@gmail.com, Ph:9851870036</span>  
        <div className="f-icons">
          <a href="https://www.instagram.com/mak.das.5/"
          className="insta social"
          >
          <Insta color="white" size={"3rem"} />
          </a>

          <a href="https://www.facebook.com/mak.das.5"
          className="facebook social"
          >
          <Facebook color="white" size={"3rem"} />
          </a>

          <a href="https://github.com/makmilon"
          className="github social"
          >
           <Gitub color="white" size={"3rem"} />
          </a>
          <a href="https://www.linkedin.com/in/themilondas/"
          className="github social"
          >
           <Linkedin color="white" size={"3rem"} />
          </a>
        
        </div>
      </div>
    </div>
  );
};

export default Footer;
